import React from 'react';
import Slider from 'react-slick'; // Import Slider
import { ArrowRight, ShieldCheck, Award, CheckCircle, Recycle, Wrench, Gauge, Zap, Package } from 'lucide-react';

const QualitySection = () => {
  const certifications = [
    {
      id: 1,
      text: 'High-Grade Recycled Steel Sourcing.',
      icon: Recycle,
    },
    {
      id: 2,
      text: 'ISO-9001 Compliant Quality Management System.',
      icon: ShieldCheck,
    },
    {
      id: 3,
      text: 'Certified Workmanship (AWS/ISO).',
      icon: Wrench,
    },
    {
      id: 4,
      text: 'Non-Destructive Testing (NDT).',
      icon: Gauge,
    },
    {
      id: 5,
      text: 'Optimized Energy Consumption.',
      icon: Zap,
    },
    {
      id: 6,
      text: 'Minimal On-Site Waste Strategy.',
      icon: Package,
    },
    {
      id: 7,
      text: 'We are CIDB and SSM Certified.',
      icon: Award, // Using Award icon for general certification
    },
  ];

  const partnerLogos = [
    { id: 1, src: '/Worked_with/concept_associates_kl_sdn_bhd_logo.jpg', alt: 'Partner 1' },
    { id: 2, src: '/Worked_with/KERINGAT SDN BHD.PNG', alt: 'Partner 2' },
    { id: 3, src: '/Worked_with/OCR Group.jpg', alt: 'Partner 3' },
    { id: 4, src: '/Worked_with/pioneer_engineering_sdn_bhd_522025_logo.jpg', alt: 'Partner 4' },
    { id: 5, src: '/Worked_with/SWAJA FACADE SDN BHD.jpg', alt: 'Partner 5' },
    { id: 6, src: '/Worked_with/tajukon_sdn_bhd_logo.jpg', alt: 'Partner 6' },
    { id: 7, src: '/Worked_with/THE LOTUS CONSTRUCTION.png', alt: 'Partner 7' },
    { id: 8, src: '/Worked_with/VISTAMORE.jpg', alt: 'Partner 8' },
    { id: 9, src: '/Worked_with/logo-website-top-left.png', alt: 'Partner 9' },
  ];

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="py-16 px-4 bg-gray-50">
      <div className="container mx-auto">
        <h2 className="text-3xl sm:text-4xl font-bold text-[#364A9A] text-center mb-8 sm:mb-12 font-poppins">
          QUALITY & CERTIFICATIONS
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {/* Left Column: Quality Assurance Banner */}
          <div
            className="lg:col-span-2 relative h-64 sm:h-80 md:h-96 rounded-lg overflow-hidden shadow-lg flex items-center justify-center p-4 sm:p-8"
            style={{ backgroundImage: "url('/hero_img/image-05.jpg')", backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-[#364A9A] to-transparent opacity-70"></div>
            <div className="relative z-10 text-white text-center lg:text-left">
              <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-4 leading-tight">
                Our Rigorous Approach to Precision & Safety
              </h3>
              <a
                href="#"
                className="inline-flex items-center text-white text-lg font-semibold hover:text-[#ECEE07] transition duration-300"
              >
                READ OUR QUALITY POLICY <ArrowRight size={20} className="ml-2" />
              </a>
            </div>
          </div>

          {/* Right Column: Certifications / Key Practices List */}
          <div className="lg:col-span-1 bg-white rounded-lg shadow-lg p-6 sm:p-8 flex flex-col justify-center">
            <ul className="space-y-3 sm:space-y-4">
              {certifications.map((item) => (
                <li key={item.id} className="flex items-start text-gray-700 text-sm sm:text-base font-serif">
                  <item.icon size={20} className="text-[#2056eb] mr-3 flex-shrink-0 mt-1" />
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Partner Logos Row */}
        <div className="py-6 sm:py-8 bg-white rounded-lg shadow-lg">
          <Slider {...sliderSettings}>
            {partnerLogos.map((logo) => (
              <div key={logo.id} className="px-2 sm:px-4">
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="mx-auto h-12 sm:h-16 md:h-20 object-contain opacity-70 hover:opacity-100 transition-opacity duration-300 grayscale hover:grayscale-0"
                />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default QualitySection;
